module.exports = __webpack_public_path__ + "static/img/banner-home.406367d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/supplychain/banner-home.png
// module id = CM7d
// module chunks = 44